import React, { /*useCallback,*/ useState, useEffect, Fragment, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";

const MesajGrubu = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);

    const [currentId, setCurrentId] = useState(0);
    const [grupAdi, setGrupAdi] = useState('');

    const [data, setData] = useState([]);
    const [dataKisi, setDataKisi] = useState([]);
    const [checkAll, setCheckAll] = useState(false);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            setShow(false);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const kisiListOnUpdate = (index, checked) => {
        const kisiListTemp = [...dataKisi];
        kisiListTemp[index].checked = checked;
        setDataKisi(kisiListTemp);
    };

    useEffect(() => {
        getAcilisData();
    }, []);

    const handleCheckAll = () => {
        setCheckAll(!checkAll);

        const temp = dataKisi;

        temp.forEach(item => {
            item.checked = !checkAll;
        });

        setDataKisi(temp);
    }

    const getAcilisData = async() => {
        if (await tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Mesajlaşma");
        
        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true){
            setDataKisi((await axios.get(settings.ApiUrl + "Lookup/GetKisiForMesaj", { headers: AuthService.getHeaders() })).data.value);
            await getData();
        }
    }

    const getData = async () => {
        try {
            const res = await axios.get(settings.ApiUrl + 'Mesaj/GetMesajGrubuMasterList/', { headers: AuthService.getHeaders() });

            if (res) {
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const Ekle = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        setCurrentId(0);
        setGrupAdi("");

        let temp = dataKisi;

        temp.forEach(kisi => {
            kisi.checked = false;
        });                    

        setDataKisi(temp);

        handleShow();
    }

    const Degistir = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Mesaj/GetMesajGrubuMaster/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setGrupAdi(result.data.value.grupAdi);

                if (dataKisi && dataKisi.length > 0 && result.data.value.mesajGrubuDetailList) {
                    let temp = dataKisi;

                    temp.forEach(kisi => {
                        const exist = result.data.value.mesajGrubuDetailList.filter(item => item.uyeKisiId === kisi.id);
                        kisi.checked = exist && exist.length > 0;
                    });

                    setDataKisi(temp);
                }

                handleShow();
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Mesaj/GetMesajGrubuMaster/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Mesaj/DeleteMesajGrubuMaster/', resultGet.data.value, { headers: AuthService.getHeaders() });
                        
                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                await getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        let kisilerTemp = dataKisi.filter(item => item.checked === true);

        if (grupAdi === "" || kisilerTemp.length === 0) {
            Swal.fire({ title: "Hata", text: "Grup adını giriniz ve en az bir grup üyesi seçiniz", icon: "error" });
        } else {
            try {
                let kisiler = [];

                kisilerTemp.forEach(element => {
                    let newItem = {
                        uyeKisiId: element.id,
                        uyeKisi: element.ad
                    };

                    kisiler.push(newItem);
                });

                const data = JSON.stringify({
                    "id": currentId,
                    "grupAdi": grupAdi,
                    "mesajGrubuDetailList": kisiler
                });
    
                const result = await axios.post(settings.ApiUrl + 'Mesaj/InsertOrUpdateMesajGrubu/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        handleClose();
                        await getData();
                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <div className="row">
                <div className="col-md-12">
                    <PageTitle></PageTitle>
                </div>
            </div>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{textAlign:"center"}}>Grup Adı</th>
                                                <th style={{textAlign:"center"}}>Grup Üyeleri</th>
                                                <th style={{textAlign:"center"}}>
                                                    <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data.length > 0 ?
                                                    data.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td align="center">{item.grupAdi}</td>
                                                                <td align="center">{item.kisiler}</td>
                                                                <td align="center">
                                                                    <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button>
                                                                    <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td align="center" colSpan="3" style={{height:"48px"}}>
                                                            Kayıt yok
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        :
                        ""
            }

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Mesaj Grubu Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblGrupAdi" style={{width:"120px"}}>Grup Adı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input aria-describedby="lblGrupAdi" type="text" className="form-control form-control-sm" value={grupAdi} onChange={(e) => setGrupAdi(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="formControlBox">
                                <div className="input-group input-group-sm" style={{padding:"3px"}}>
                                    <input id="cbCheckAll" type="checkbox" checked={checkAll} onChange={handleCheckAll} className="form-check-input" style={{fontSize:"small"}}></input>
                                    <label htmlFor="cbCheckAll" className="labelForCheckBoxOrRadio" style={{fontWeight: "bold"}}>Tüm Kullanıcılar</label>
                                </div>
                                <div style={{overflowY: "auto", height: "200px"}}>
                                    <table className="table table-hover table-sm table-borderless" style={{width:"auto"}}>
                                        <tbody>
                                            {
                                                dataKisi && dataKisi.length > 0 ?
                                                dataKisi.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <input id={"cbKisi" + item.id} type="checkbox" className="form-check-input" checked={item.checked} onChange={() => kisiListOnUpdate(index, !item.checked)}></input>
                                                            </td>
                                                            <td>
                                                                <label htmlFor={"cbKisi" + item.id} style={{cursor:"pointer"}}>{item.ad}</label>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={2}>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleClose}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default MesajGrubu;